import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sunrise } from "lucide-react";
import { getResurfacedDrafts } from "@/lib/storage";
import { WELCOME_BANNER } from "@/constants/testIds";

/**
 * HeldDraftsBanner — appears on Welcome when last-night drafts have resurfaced.
 * Soft amber tone, never alarming.
 */
export default function HeldDraftsBanner() {
  const nav = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(getResurfacedDrafts().length);
  }, []);

  if (count <= 0) return null;

  return (
    <motion.button
      data-testid={WELCOME_BANNER.heldDrafts}
      onClick={() => nav("/drafts")}
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className="relative w-full overflow-hidden rounded-3xl p-4 mb-5 text-left un-press"
      style={{
        background:
          "linear-gradient(135deg, #FBF6EF 0%, #F0E4D8 65%, #EBE5D9 100%)",
        boxShadow: "0 8px 26px rgba(74,32,64,0.08)",
      }}
    >
      <div className="flex items-start gap-3">
        <Sunrise
          size={18}
          className="mt-0.5 shrink-0"
          style={{ color: "var(--un-terracotta)" }}
        />
        <div>
          <p
            className="text-[14px] font-medium leading-snug"
            style={{
              color: "var(--un-text-1)",
              fontFamily: "Manrope, sans-serif",
            }}
          >
            {count} message{count > 1 ? "s" : ""} you held last night.
          </p>
          <p
            className="text-[15px] italic mt-0.5"
            style={{
              color: "var(--un-text-2)",
              fontFamily: "Cormorant Garamond, serif",
            }}
          >
            Still want to send? Does it still feel true?
          </p>
        </div>
      </div>
    </motion.button>
  );
}
